import { UseMutateFunction } from 'react-query';

export const ANIMATION_CLASSNAME = 'awt-moments-banner--animate';

export type BannerMetadata = {
  claimBtnText: string;
  description: string;
  graphicSrc: string;
  isEnabled: boolean;
  title: string;
};

export type MomentApplication = {
  id: string;
  isEarned: boolean;
  isClaimed: boolean;
  canBeClaimed: boolean;
  earnedDates: unknown;
  unearnedDates: unknown;
  claimedDates: unknown;
  moment: Moment;
};

export type Moment = {
  id: string;
  position: number;
  displayName: string;
  description: string;
  isUnearnable: boolean;
  isReearnable: boolean;
  actions: unknown[];
  isVisible: boolean;
  badgeOnSrc: string;
  badgeOffSrc: string;
  canBeClaimed: boolean;
  claimBannerMetadata: BannerMetadata;
  availableProductList?: ProductListProduct[];
};

export type MomentApplicationMutate = UseMutateFunction<
  string,
  undefined,
  { momentId: string; productVariantGId?: string },
  MomentApplication[]
>;

export interface IMomentsContext {
  className: string;
  moments: MomentApplication[];
  momentsForClaim: MomentApplication[];
  momentsForDismiss: MomentApplication[];
  isLoading: boolean;
  isClaiming: boolean;
  onAnimationEnd: () => void;
  handleClaimReward: (moment: MomentApplication) => void;
  dismissReward: (moment: MomentApplication['moment']) => void;
  setSwiperRef: (ref: unknown) => void;
  productList: GlobalProduct[];
  isProductListModalOpen: boolean;
  handleClaimProductListReward: (productVariantId: string) => void;
  handleOpenProductListModal: () => void;
  handleCloseProductListModal: () => void;
}

export interface ProductListProduct {
  description: string;
  descriptionHtml: string;
  featuredImage: {
    transformedSrc: string;
  };
  handle: string;
  id: string;
  images: {
    url: string;
  }[];
  options: {
    id: string;
    name: string;
    values: string[];
    position: number;
  }[];
  priceRangeV2: {
    maxVariantPrice: {
      amount: string;
      currencyCode: string;
    };
    minVariantPrice: {
      amount: string;
      currencyCode: string;
    };
  };
  status: string;
  title: string;
  totalVariants: number;
  variants: ProductListProductVariant[];
  discountedPriceMin: string;
  discountedPriceMax: string;
}

export interface ProductListProductVariant {
  availableForSale: boolean;
  displayName: string;
  gId: string;
  id: string;
  image: {
    transformedSrc: string;
  };
  price: string;
  product: ProductListProduct;
  selectedOptions: {
    name: string;
    value: string;
  }[];
  sellableOnlineQuantity: number;
  sellingPlanGroups: SellingPlanGroup[];
  title: string;
  compareAtPrice: string;
}
